import {
  preservePlanningFiltersOnLogout,
  restorePlanningFiltersAfterLogout,
} from '../../modules/planning/utils/planningFilterStorage';

/**
 * @description checks for access_token and adds appropriate headers
 * @param config : request interceptor configuration object
 */
const authorizeRequest = config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['access-token'] = token;
    config.headers.client = localStorage.getItem('client');
    config.headers.uid = localStorage.getItem('uid');
    if (localStorage.getItem('locale'))
      config.headers.locale = localStorage.getItem('locale');
  }
};

/**
 * @description handles unauthorized responses, preserves filters, and redirects user to login page
 * @param error : error object returned from failed response
 * @returns original error object
 */
// TODO: display error instead of hard redirect
const redirectUnauthorized = error => {
  if (error.response.status === 401) {
    const { savedFilters } = preservePlanningFiltersOnLogout();
    localStorage.clear();
    // Save the current route for redirect after login
    const ignoredRotes = ['login', '/login', '/password/reset', '/password/change']
    if (!ignoredRotes.includes(window.location.pathname)) {
      localStorage.setItem('beforeLoginroute', window.location.pathname);
    }

    // Restore filters
    if (savedFilters) {
      restorePlanningFiltersAfterLogout({ savedFilters });
    }
    window.location.href = '/login';
  }
  return error;
};

// adds interceptors to middleware chain
export default api => {
  api.interceptors.request.use(config => {
    authorizeRequest(config);
    return config;
  });

  // always return Promise.reject on error, or it will not be caught by try/catch block
  api.interceptors.response.use(
    response => response,
    error => {
      redirectUnauthorized(error);
      return Promise.reject(error);
    }
  );

  return api;
};
